import { all, fork } from "redux-saga/effects";
import todoSaga from "../../redux/Language/saga";
import toAccount from "../../redux/Accounts/saga"
import toCustomerSaga from "@redux/User/saga";
import toPopupSaga from "@redux/Popup/saga";
import toMediaSaga from "@redux/Media/saga";
export function* rootSaga() {
    yield all([fork(todoSaga)]);
    yield all([fork(toAccount)]);
    yield all([fork(toCustomerSaga)]);
    yield all([fork(toPopupSaga)]);
    yield all([toMediaSaga()]);
}
